var _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSugar = function SvgSugar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUNDS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.14,278.53h0a1.72,1.72,0,0,0,.33-.52A1.72,1.72,0,0,1,543.14,278.53Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.47,278a.78.78,0,0,0,0-.47A.78.78,0,0,1,543.47,278Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.13,255.66q.78,3.06,1.57,6.12-.8-3.06-1.57-6.12Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.39,253.93a3.34,3.34,0,0,1,.11-.67A3.34,3.34,0,0,0,537.39,253.93Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.65,290.05a4.54,4.54,0,0,0,0,1.27A4.54,4.54,0,0,1,544.65,290.05Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.94,333.92q-74.49-.18-149-.3,0-66,.08-132,0,66-.08,132.05Q375.45,333.77,449.94,333.92Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.22,293.45c.06,1.41,0,2.85.14,4.24-.15-1.39-.08-2.83-.14-4.24Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.89,339.85q.24-2.89.52-5.77h0Q546.13,337,545.89,339.85Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.06,349.38c-.25,2.64-.53,5.28-.88,7.91C544.53,354.66,544.81,352,545.06,349.38Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.7,255.13a2.1,2.1,0,0,1-.31-1.17A2.1,2.1,0,0,0,537.7,255.13Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.77,201.19q-78.27,0-156.54.06c1.07-8.79,3.41-17.3,5.78-25.78-2.37,8.48-4.71,17-5.78,25.79-.1,16.62-.27,33.25-.34,49.87.07-16.62.24-33.25.34-49.88Q217.5,201.22,295.77,201.19Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.56,262.74a1.41,1.41,0,0,1,0-.46A1.41,1.41,0,0,0,539.56,262.74Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.54,282.83a2.63,2.63,0,0,1,.15-.75A2.63,2.63,0,0,0,543.54,282.83Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.58,283.56a3,3,0,0,1,0-.67A3,3,0,0,0,543.58,283.56Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.12,320.35a51.47,51.47,0,0,1,.3-6.08A51.47,51.47,0,0,0,546.12,320.35Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.58,78.65q-29.11.12-58.25.21l-10.1,0,10.1,0Q351.46,78.76,380.58,78.65Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.47,205.7c-.17-1.48-.53-3-.75-4.44-.83-4.45-1.53-8.93-2.53-13.34,1,4.41,1.7,8.89,2.53,13.34C464.94,202.74,465.3,204.22,465.47,205.7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.27,415.35c-.15,33.1-.36,66.19-.42,99.29.06-33.1.27-66.19.42-99.29Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.14,558q-75.6-.13-151.2-.23l0-20.24,0,20.24Q376.54,557.93,452.14,558Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.12,320.35c0,4.58.44,9.16.29,13.73h0l.4.2.44,0V309.72a31.31,31.31,0,0,0-.83,4.55A51.47,51.47,0,0,0,546.12,320.35Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.5,301.29c-1.48,1.7.42,2.79.75,4.17v-4.27A.55.55,0,0,0,546.5,301.29Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.82,85.76c2.69,27.4-4.24,53.45-11,79.55-.39,1.49-.79,3-1.2,4.46q-.78,2.85-1.58,5.7c-2.37,8.48-4.71,17-5.78,25.78q78.27,0,156.54-.06c1.76,0,3.51.25,5.27.38l146.33-.23c5.78,0,11.57-.05,17.35-.08-.83-4.45-1.53-8.93-2.53-13.34-7.78-34-20.69-67.18-17.21-103.1.43-4.37-1.55-6.45-6.14-6.43q-29.13.17-58.26.26t-58.25.21v75.69c-5.61-4.07-9.92-7-14-10.2-4.48-3.57-8.34-4.21-12.89.23-3.55,3.47-8,6-13.65,10.19v-76c-38.78-.12-77.56-.17-116.34-.42C159.91,78.31,158.35,80.91,158.82,85.76Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,415.69q-32.46.12-64.94.29h0L301,537.57l0,20.24q75.6.12,151.2.23c4.28,0,8.56.16,12.84.24.21-2.5.6-5,.6-7.5q0-63.58,0-127.17c0-2.75-.4-5.51-.61-8.26h0Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.94,557.81l0-20.24L301.08,416h0c-1.75-.09-3.51-.22-5.26-.34s-3.51-.2-5.27-.2q-20.42-.06-40.84-.09H139.27c-.15,33.1-.36,66.19-.42,99.29,0,14.57.28,29.14.44,43.71l151.1-.18C293.91,558.16,297.42,557.94,300.94,557.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.37,201.34,301,201.57q0,66-.08,132.05,74.49.15,149,.3c5,0,10.08.19,15.12.29a40.3,40.3,0,0,0,.5-4.49q.06-61.26,0-122.54a12.37,12.37,0,0,0-.09-1.48c-.17-1.48-.53-3-.75-4.44C458.94,201.29,453.15,201.33,447.37,201.34Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,333.62q0-66,.08-132c-1.76-.13-3.51-.38-5.27-.38q-78.27,0-156.54.06c-.1,16.63-.27,33.26-.34,49.88q0,8.33,0,16.63c0,22.17.27,44.33.41,66.5q75.59-.09,151.15-.2C293.93,334.05,297.44,333.77,301,333.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.94,333.92q-74.49-.18-149-.3c-3.52.15-7,.43-10.55.44q-75.57.13-151.15.2H465v81.09h0c.84-27.05.63-54.09.1-81.14C460,334.11,455,333.93,449.94,333.92Z",
    fill: "#2ca5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.71,415.35q20.41,0,40.84.09c1.76,0,3.51.09,5.27.2s3.51.25,5.26.34h0q32.48-.14,64.94-.29l98.93-.34Z",
    fill: "#2ca5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.14,558q-75.6-.13-151.2-.23c-3.52.13-7,.35-10.55.36l-151.1.18c-.12,7.55.14,15.13-.46,22.65-.51,6.42,1.9,8,8.08,8,53.17-.2,106.35-.08,159.52-.06,50.4,0,100.81-.11,151.21.14,6.39,0,8.43-1.89,7.94-8.12-.15-1.88-.25-3.76-.32-5.64-.21-5.66-.15-11.33-.28-17C460.7,558.2,456.42,558.05,452.14,558Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.82,154.77c5.67-4.16,10.1-6.72,13.65-10.19,4.55-4.44,8.41-3.8,12.89-.23,4.05,3.23,8.36,6.13,14,10.2V78.86l-10.1,0-30.41-.07Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,289.54c0,.18-.09.34-.12.51a4.54,4.54,0,0,0,0,1.27,6.18,6.18,0,0,0,.62,2.13h0C546.14,292,546.17,290.7,544.77,289.54Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.69,282.08a2.63,2.63,0,0,0-.15.75s0,0,0,.06a3,3,0,0,0,0,.67,3.59,3.59,0,0,0,.58,1.36A1.71,1.71,0,0,0,543.69,282.08Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.5,253.26a3.34,3.34,0,0,0-.11.67v0a2.1,2.1,0,0,0,.31,1.17,2.33,2.33,0,0,0,.43.53h0A2,2,0,0,0,537.5,253.26Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.7,261.78a1.67,1.67,0,0,0-.15.5,1.41,1.41,0,0,0,0,.46,1.6,1.6,0,0,0,.49.84C540.66,262.84,540.41,262.26,539.7,261.78Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.68,266.05l.39,1.8C541.69,267.09,541.44,266.52,540.68,266.05Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.8,271.38c.12.6.23,1.2.35,1.8C542.78,272.44,542.55,271.86,541.8,271.38Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.52,277.54a1.41,1.41,0,0,0-.68-.83l.3,1.82h0a1.72,1.72,0,0,0,.33-.52A.78.78,0,0,0,543.52,277.54Z",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.71 415.35 464.95 415.35 464.95 334.26 139.26 334.26 139.26 415.35 139.27 415.35 139.27 415.35 249.71 415.35",
    fill: "#6ab4e5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.74,89a3.15,3.15,0,0,0,3.1,3.09c1.43.24,2.85-1.19,2.85-2.86C550.8,59,576.37,58.28,579.5,58.26c15.77-10.81-30,1.12-28.57-37.38-10.63-15.93,1.76,31-34.76,31a3.09,3.09,0,0,0-3.1,3.09C517,63.08,543.76,53.1,544.74,89Z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSugar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sugar.aa7a3e37.svg";
export { ForwardRef as ReactComponent };